<template>
    <LayoutBase>
		<template v-if="!$wait.is('fetching preview resource')">
			<section class="preview-section">
                <header class="preview-section__header">
					<h2 class="h1">The Project</h2>
					<router-link :to="stepLink(1)" class="btn" v-if="canCompleteStep(1)">Edit</router-link>
				</header>

				<template v-if="completedStep(1)">
					<div class="company-info">
						<h2>{{ resource.projectName }}</h2>
					</div>
					<div v-if="resource.lead" class="profile-list">
						<p class="profile-list__title">Lead User</p>

						<UserCard :user="resource.lead" :borderless="true"></UserCard>
					</div>
					<div v-if="filterLead(resource.team).length" class="profile-list">
						<p class="profile-list__title">Users also involved</p>
						<div class="grid">
							<div class="col-3" v-for="profile in filterLead(resource.team)" :key="profile.id">
								<UserCard :user="profile" :small="true" :borderless="true"></UserCard>
							</div>
						</div>
					</div>
				</template>

				<p v-else>Not completed</p>

			</section>

			<section class="preview-section">
				<header class="preview-section__header">
					<h2 class="h1">The Company</h2>
					<router-link :to="stepLink(2)" class="btn" v-if="canCompleteStep(2)">Edit</router-link>
				</header>

				<template v-if="completedStep(2)">
					<div class="company-info">

						<img
                            :src="resource.country.flag"
                            v-if="resource.member.country"
                            v-tippy="resource.country.name"
                        />
						<h2>{{ resource.companyName }}</h2>
						<ul class="grid post-details">
							<li v-if="resource.completedAt" class="col-3 detail">
								<span class="label">Completed Date</span>
								<span class="h3"><SvgIcon :icon="'calendar'" /> {{ resource.completedAt }}</span>
							</li>
							<li v-if="resource.location" class="col-3 detail">
								<span class="label">Location of Activities</span>
								<span class="h3"><SvgIcon :icon="'location'" /> {{ resource.location }}</span>
							</li>
							<li v-if="resource.dealType" class="col-3 detail">
								<span class="label">Deal Type</span>
								<span class="h3"><SvgIcon :icon="'deal'" /> {{ resource.dealType }}</span>
							</li>
							<li v-if="resource.counterpartCompany" class="col-3 detail">
								<span class="label">Counterpart Company</span>
								<span class="h3"><SvgIcon :icon="'company'" /> {{ resource.counterpartCompany }}</span>
							</li>
						</ul>
						<div id="bio" class="card" v-if="resource.activity">
							<div class="header">Company Bio</div>
							<div v-html="resource.activity"></div>
						</div>
                        <div id="tombstone" class="card" v-if="resource.tombstone">
                            <div class="header">Tombstone company description</div>
                            <div v-html="resource.tombstone"></div>
                        </div>
					</div>
				</template>

				<p v-else>Not completed</p>
			</section>

			<section class="preview-section">
				<header class="preview-section__header">
					<h2 class="h1">The Deal</h2>
					<router-link :to="stepLink(3)" class="btn" v-if="canCompleteStep(3)">Edit</router-link>
				</header>

				<template v-if="completedStep(3)">
					<ul class="grid post-details">
						<li v-if="resource.transactionCurrency" class="col-2 detail">
							<span class="label">Currency</span>
							<strong><SvgIcon :icon="'money'" /> {{ resource.transactionCurrency }}</strong>
						</li>
						<li v-if="resource.transactionValue" class="col-2 detail">
							<span class="label">Transaction Value</span>
							<strong><SvgIcon :icon="'value'" /><span v-if="resource.transactionCurrency">{{ resource.transactionCurrency }}</span>  {{ resource.transactionValue }}m</strong>
						</li>
						<li v-if="resource.sectors" class="col-6 detail">
							<span class="label">Sectors</span>
							<span class="sector" v-for="sector in resource.sectors">{{ sector.name }}</span>
						</li>
					</ul>
					<div id="summary" class="card" v-if="resource.dealSummary">
						<div class="header">Deal Summary</div>
						<div v-html="resource.dealSummary"></div>
					</div>
				</template>

				<p v-else>Not completed</p>
			</section>

			<section class="preview-section">
				<header class="preview-section__header">
					<h2 class="h1">The Impact</h2>
					<router-link :to="stepLink(4)" class="btn" v-if="canCompleteStep(4)">Edit</router-link>
				</header>

				<template v-if="completedStep(4)">
					<div class="card" v-if="resource.differenceMade">
						<div class="header">The value the user added to the project</div>
						<div v-html="resource.differenceMade"></div>
					</div>
					<div class="card" v-if="resource.testimonial">
						<div class="header">Testimonial</div>
						<div v-html="resource.testimonial"></div>
						<br />
						<span v-if="resource.testimonialPerson">- {{ resource.testimonialPerson }}</span>
					</div>
				</template>

				<p v-else>Not completed</p>
			</section>

			<div class="form">
				<div class="form__group form__group--submit-fixed">
					<button @click="showDeleteModal()" class="btn btn--danger" v-if="resource.can.delete"
					        v-wait:disabled="['saving preview resource', 'deleting preview resource']">
						Delete MADD
					</button>
					<button @click="saveResource(0)" class="btn" v-wait:disabled="'saving preview resource'">
						Save and Leave
					</button>

					<button @click="saveResource(2)" class="btn btn--primary btn--no-stretch"
					        v-if="resource.can.approve" v-wait:disabled="'saving preview resource'">
						Approve and Post
					</button>
					<button @click="saveResource(1)" class="btn btn--primary btn--no-stretch"
					        v-else-if="resource.can.submit" v-wait:disabled="'saving preview resource'">
						Submit MADD
					</button>
				</div>
			</div>
		</template>
	</LayoutBase>
</template>
<script>
	import LayoutBase from '../Layout/LayoutBase';
	import API from '../../api';
	import SvgIcon from '../SvgIcon';
	import ResourcePreview from '../ResourcePreview';
	import UserCard from '../User/UserCard';

	export default {
		name: 'MADDPreview',
		mixins: [ResourcePreview],
		components: {
			UserCard,
			LayoutBase,
			SvgIcon,
		},
		data() {
			return {
				resource: {
					team: [],
				},
				deleteModal: {
					title: 'Are you sure you want to delete this MADD?',
					buttonLabel: 'Delete MADD',
				}
			}
		},
		methods: {
			stepLink(step) {
				return { name: 'edit-madd-step', params: { step: step, madd_id: this.id }}
			},
			fetchResource() {
				return API.getMADD(this.id);
			},
			updateResource(status) {
				return API.updateMADD(this.id, null, { status }).then(() => {
					this.$router.push({
						name: 'view-madd',
						params: {madd_id: this.id},
					});
				});
			},
			deleteResource() {
                return API.deleteMADD(this.id).then(() => {
                    this.$router.push({ name: 'madds' });
                });
			},
			filterLead(users) {
				if(typeof users === 'undefined') {
					return [];
				}

				return users.filter(user => {
					return user.id !== this.resource.lead.id;
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	#bio,
	#summary,
	.card + .card{
		margin-top: 2rem;
	}
</style>
